/* ============================================
   CustomSolo DTC — Main Interactions v4
   Christmas Design: Snow animation, filters, gallery, tabs
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── MEGA MENU INJECTION ── */
  // Copy content from mega-menu data sections (rendered in hidden .mega-menu-data-store)
  // into header dropdown placeholders so the menu is fully driven by editable sections.
  function injectMegaMenus() {
    var placeholders = document.querySelectorAll('[data-menu-placeholder]');
    placeholders.forEach(function(placeholder) {
      var menuId = placeholder.getAttribute('data-menu-placeholder');
      var source = document.querySelector('.mega-menu-data-source[data-menu-id="' + menuId + '"]');
      if (source) {
        placeholder.innerHTML = source.innerHTML;
      }
    });
  }
  injectMegaMenus();

  /* ── SNOW ANIMATION (DOM-based, like old landing page) ── */
  const snowContainer = document.getElementById('snowContainer');
  if (snowContainer) {
    const flakes = ['\u2744', '\u2745', '\u2746', '\u2726', '\u2727'];
    for (let i = 0; i < 30; i++) {
      const flake = document.createElement('div');
      flake.className = 'snowflake';
      flake.textContent = flakes[Math.floor(Math.random() * flakes.length)];
      flake.style.left = Math.random() * 100 + '%';
      flake.style.fontSize = (Math.random() * 14 + 10) + 'px';
      flake.style.animationDuration = (Math.random() * 8 + 8) + 's';
      flake.style.animationDelay = (Math.random() * 10) + 's';
      flake.style.opacity = Math.random() * 0.5 + 0.3;
      snowContainer.appendChild(flake);
    }
  }

  /* ── MOBILE MENU TOGGLE ── */
  // Skip if critical.js already initialized (Safari file:// compatibility)
  if (window.__MOBILE_MENU_INITIALIZED__) return;
  window.__MOBILE_MENU_INITIALIZED__ = true;

  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileOverlay = document.querySelector('.mobile-nav-overlay');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      menuToggle.classList.toggle('active');
      if (mobileOverlay) {
        if (mobileNav.classList.contains('open')) {
          mobileOverlay.classList.add('show');
        } else {
          mobileOverlay.classList.remove('show');
        }
      }
    });
    // close on link click
    mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      mobileNav.classList.remove('open'); menuToggle.classList.remove('active');
      if (mobileOverlay) mobileOverlay.classList.remove('show');
    }));
  }

  /* ── MULTI-DIMENSIONAL COLLECTION FILTERS — Left Sidebar Checkboxes ── */
  // Skip if critical.js already initialized (Safari file:// compatibility)
  if (window.__FILTERS_INITIALIZED__) return;

  const sidebar = document.querySelector('.filter-sidebar');
  const checkboxes = sidebar ? sidebar.querySelectorAll('.filter-checkbox[data-filter]') : [];
  const productCards = document.querySelectorAll('.product-card[data-tags]');

  window.__FILTERS_INITIALIZED__ = true;

  if (checkboxes.length && productCards.length) {
    const activeFilters = {}; // { recipient: Set(), price: Set(), material: Set(), ... }

    function getFilterInfo(cb) {
      const filterVal = cb.dataset.filter;
      if (['bestsellers', 'featured', 'new'].includes(filterVal)) {
        return { group: 'promo', value: filterVal };
      }
      if (filterVal.includes(':')) {
        const [g, v] = filterVal.split(':');
        return { group: g, value: v };
      }
      return { group: null, value: null };
    }

    function applyFilters() {
      let visibleCount = 0;
      const groups = Object.keys(activeFilters).filter(g => activeFilters[g].size > 0);

      productCards.forEach(card => {
        const tags = (card.dataset.tags || '').split(' ');
        let show = true;

        for (const group of groups) {
          const groupFilters = activeFilters[group];
          let matched = false;
          for (const f of groupFilters) {
            if (tags.includes(group + ':' + f) || tags.includes(f)) {
              matched = true;
              break;
            }
          }
          if (!matched) { show = false; break; }
        }

        if (show) {
          card.style.display = '';
          card.style.animation = 'fadeIn .4s ease both';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      const countEl = document.getElementById('visibleCount');
      if (countEl) countEl.textContent = visibleCount;

      const clearBtn = document.getElementById('clearAllFilters');
      if (clearBtn) clearBtn.style.display = groups.length > 0 ? 'inline-block' : 'none';

      const emptyEl = document.getElementById('filterEmpty');
      const gridEl = document.querySelector('.product-grid');
      if (emptyEl) emptyEl.style.display = visibleCount === 0 ? '' : 'none';
      if (gridEl && visibleCount === 0) gridEl.style.display = 'none';
      else if (gridEl) gridEl.style.display = '';
    }

    checkboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        const { group, value } = getFilterInfo(cb);
        if (!group) return;

        if (!activeFilters[group]) activeFilters[group] = new Set();

        if (cb.checked) {
          activeFilters[group].add(value);
        } else {
          activeFilters[group].delete(value);
        }

        applyFilters();
      });
    });

    // Collapse / Expand filter sections
    const toggles = sidebar.querySelectorAll('.filter-section-toggle');
    toggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const section = toggle.closest('.filter-section');
        if (section) section.classList.toggle('collapsed');
      });
    });

    // Clear all filters
    const clearAllBtn = document.getElementById('clearAllFilters');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', () => {
        Object.keys(activeFilters).forEach(g => activeFilters[g].clear());
        checkboxes.forEach(c => c.checked = false);
        applyFilters();
      });
    }
  }

  /* ── SORT (client-side by price text) ── */
  const sortSelect = document.getElementById('sort-select');
  const gridContainer = document.querySelector('.product-grid');
  if (sortSelect && gridContainer) {
    sortSelect.addEventListener('change', () => {
      const cards = Array.from(gridContainer.querySelectorAll(':scope > .product-card'));
      const val = sortSelect.value;
      cards.sort((a, b) => {
        const pa = parseFloat(a.dataset.price || '0');
        const pb = parseFloat(b.dataset.price || '0');
        return val === 'price-asc' ? pa - pb : val === 'price-desc' ? pb - pa : 0;
      });
      cards.forEach(c => gridContainer.appendChild(c));
    });
  }

  /* ── PRODUCT DETAIL: GALLERY THUMBNAIL SWAP ── */
  const mainImg = document.querySelector('.gallery-main img');
  const thumbs = document.querySelectorAll('.gallery-thumb');
  if (mainImg && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const newSrc = thumb.querySelector('img')?.src;
        if (!newSrc) return;
        mainImg.style.opacity = '0';
        setTimeout(() => { mainImg.src = newSrc; mainImg.style.opacity = '1'; }, 150);
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  /* ── PRODUCT DETAIL: TAB SWITCHING ── */
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');
  if (tabBtns.length) {
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        tabBtns.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));
        btn.classList.add('active');
        const content = document.getElementById(target);
        if (content) content.classList.add('active');
      });
    });
  }

  /* ── QUANTITY CONTROLS ── */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.qty-value');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus' && val > 1) input.value = val - 1;
      if (btn.dataset.action === 'plus') input.value = val + 1;
    });
  });

  /* ── ADD TO CART FEEDBACK ── */
  document.querySelectorAll('.btn-add-to-cart').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const orig = btn.innerHTML;
      btn.innerHTML = '✓ Added to Cart';
      btn.disabled = true;
      btn.style.background = 'var(--green)';
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) cartCount.textContent = parseInt(cartCount.textContent || '0') + 1;
      setTimeout(() => { btn.innerHTML = orig; btn.disabled = false; btn.style.background = ''; }, 2000);
    });
  });

  /* ── SCROLL ANIMATIONS ── */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('animate-in');
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

  /* ── FALLBACK: Ensure all data-animate elements become visible ── */
  // If IntersectionObserver doesn't fire (e.g. element already in viewport edge case),
  // force-show all animated elements after 1.5s
  setTimeout(() => {
    document.querySelectorAll('[data-animate]:not(.animate-in)').forEach(el => {
      el.classList.add('animate-in');
    });
  }, 1500);

});
